<template>
  <div class="images">
    <n-upload-button accept="image/*" multiple @change="handleAddImageChange">
      {{$t('editor.images.add-image')}}
    </n-upload-button>
    <div class="image-list">
      <div class="image" v-for="[name, image] in cropData.images" :key="`image-${name}`">
        <n-input-text
          :label="$t('editor.images.name')"
          :value="name"
          @change="handleRenameImageChange($event, name)" />
        <img class="image__source" :src="image.src" />
        <button class="button--remove" type="button" @click="handleRemoveImageClick($event, name)">
          <n-icon-base>
            <n-icon-delete />
          </n-icon-base>
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.images {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
}

.image__source {
  max-width: 6rem;
}

</style>

<script>
import { mapState, mapMutations } from 'vuex'

import IconBase from '@/components/icons/IconBase'
import IconDelete from '@/components/icons/IconDelete'
import InputText from '@/components/InputText'
import UploadButton from '@/components/UploadButton'

export default {
  components: {
    'n-icon-base': IconBase,
    'n-icon-delete': IconDelete,
    'n-upload-button': UploadButton,
    'n-input-text': InputText
  },
  computed: {
    ...mapState({
      cropData: (state) => state.crop.data,
      selection: (state) => state.editor.selection
    })
  },
  methods: {
    ...mapMutations({
      addImages: 'crop/addImages',
      renameImage: 'crop/renameImage',
      removeImage: 'crop/removeImage'
    }),
    handleRenameImageChange (e, name) {
      this.renameImage({ oldName: name, newName: e.target.value })
      this.$forceUpdate()
    },
    handleRemoveImageClick (e, name) {
      this.removeImage(name)
      this.$forceUpdate()
    },
    handleAddImageChange (e) {
      this.addImages({
        images: Array.from(e.target.files)
          .map((file) => {
            const image = new Image()
            image.src = URL.createObjectURL(file)
            image.crossOrigin = 'anonymous'
            return [file.name, image]
          })
      })
      this.$forceUpdate()
    }
  }
}
</script>
